module.exports = __webpack_public_path__ + "img/dropdownEle.cd533fcd.svg";